var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabItem",class:{ active: _vm.isActive },on:{"click":_vm.itemClick}},[_c('p',{staticClass:"tab_bar"}),_c('div',{staticClass:"tab_news"},[_vm._t("item-img"),_vm._t("item-name")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }